import React from "react";
import Blogs from "../Blogs/Blogs";
import Contact from "../Contact/Contact";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import MySkill from "../MySkill/MySkill";
import Projects from "../Projects/Projects";
const Home = () => {
  return (
    <div>
      <Header />
      <MySkill />
      <section >
        <h2
          className="text-center text-style mt-5"
          style={{ fontFamily: `'Bebas Neue', cursive` }}
        >
          My Personal Projects
        </h2>
        <Projects />
      </section>
      <section style={{height:'100vh'}}>
        <h2
          className="text-center text-style mt-5"
          style={{ fontFamily: `'Bebas Neue', cursive` }}
        >
          My Blogs
        </h2>
        <Blogs/>
      </section>
      <section style={{height:'100vh'}}>
        <h2
          className="text-center text-style mt-5"
          style={{ fontFamily: `'Bebas Neue', cursive` }}
        >
          Contact With Me
        </h2>
        <Contact/>
        <Footer/>
      </section>
     
    </div>
  );
};

export default Home;
